import React, { useState, useEffect, useRef } from "react";
import "./FloatingQuoteButton.css"; // Import CSS file

const FloatingQuoteButton = ({ prdctNmbr }) => {
  const [showForm, setShowForm] = useState(false);
  const modalRef = useRef(null); // Ref for the modal

  const zohoFormBaseUrl =
    "https://forms.zohopublic.com/ampthink/form/GetaQuote/formperma/M6omWPmrydiKPCKtSMDdHNXw7kktCDI_JAkL6Um_NtY";
  const prefilledUrl = `${zohoFormBaseUrl}?zf_rszfm=1&SingleLine1=${encodeURIComponent(prdctNmbr)}`;

  // Close modal when clicking outside of it
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        setShowForm(false);
      }
    };

    if (showForm) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showForm]);

  return (
    <div>
      <button className="floating-quote-button" onClick={() => setShowForm(true)}>
        GET A QUOTE
      </button>

      {showForm && (
        <div className="floating-quote-overlay">
          <div className="floating-quote-form" ref={modalRef}>
            <button className="close-button" onClick={() => setShowForm(false)}>
              ✕
            </button>

            <iframe
              src={prefilledUrl}
              style={{ width: "100%", height: "100%", border: "none" }}
              title="Get a Quote"
            ></iframe>
          </div>
        </div>
      )}
    </div>
  );
};

export default FloatingQuoteButton;
